import { Platform } from '@/core/settings/interfaces/Platform';
import { getPlatform } from '@/core/settings/utils';

export const unitParser: Record<
  Platform,
  { singular: string; plural: string }
> = {
  es: {
    singular: 'año',
    plural: 'años',
  },
  fr: {
    singular: 'année',
    plural: 'années',
  },
  gb: {
    singular: 'year',
    plural: 'years',
  },
  it: {
    singular: 'anno',
    plural: 'anni',
  },
  de: {
    singular: 'Jahr',
    plural: 'Jahre',
  },
};

export const getUnit = (unit: string, value: string): string => {
  const platform = getPlatform();
  const possibleUnits = unitParser[platform];
  if (unit === possibleUnits.singular) {
    return parseFloat(value) === 1
      ? unitParser[platform].singular
      : unitParser[platform].plural;
  }
  return unit;
};
